var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleButtonover1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Circle_Button_over",
    "data-name": "Circle Button over",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bbe36c;\n      }\n\n      .cls-2 {\n        fill: rgba(253,73,198,0.35);\n        opacity: 0;\n      }\n\n      .cls-3 {\n        fill: #2f2f2f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-1",
    width: 48,
    height: 48,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ICON_feather_twitter_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Icon [ICON=feather/twitter][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_twitter_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/twitter][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-2",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.833 2.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_122acb5b-c712-45e0-b3fa-86cf9e079aee",
    "data-name": "122acb5b-c712-45e0-b3fa-86cf9e079aee",
    className: "cls-3",
    d: "M14.981,1.809A4.983,4.983,0,0,1,18.3,3.077a8.97,8.97,0,0,0,2.082-1.093.909.909,0,0,1,1.408.958,7.918,7.918,0,0,1-1.813,3.432c.013.146.02.293.021.441a14.675,14.675,0,0,1-1.013,5.507,12.083,12.083,0,0,1-2.751,4.146A12.362,12.362,0,0,1,7.5,19.94,14.554,14.554,0,0,1,.468,18.068a.909.909,0,0,1,.478-1.7c.127.005.257.008.384.008a9.639,9.639,0,0,0,4.048-.887A8.683,8.683,0,0,1,1.024,8.223,12.035,12.035,0,0,1,1.9,3.267a.909.909,0,0,1,1.575-.153A8.793,8.793,0,0,0,10,6.824a4.983,4.983,0,0,1,4.981-5.016Zm3.075,3.218a.909.909,0,0,1-.686-.312,3.164,3.164,0,0,0-5.551,2.118s0,.008,0,.012v.91a.909.909,0,0,1-.886.909c-.091,0-.184,0-.275,0A10.612,10.612,0,0,1,3.1,5.495a9.918,9.918,0,0,0-.253,2.7c.153,2.916,1.768,5.077,4.8,6.425a.909.909,0,0,1,.141,1.583,11.494,11.494,0,0,1-3.267,1.534,12.122,12.122,0,0,0,2.986.38,10.555,10.555,0,0,0,7.462-2.953,11.366,11.366,0,0,0,3.218-8.351,3.142,3.142,0,0,0-.056-.581.909.909,0,0,1,.254-.82,6.112,6.112,0,0,0,.562-.637q-.309.114-.625.209A.908.908,0,0,1,18.055,5.027Z",
    transform: "translate(-1.742 -3.365)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleButtonover1);
export default __webpack_public_path__ + "static/media/Circle Button over-1.a019d35f3a4b781f0c38e4a1202afac3.svg";
export { ForwardRef as ReactComponent };